module.exports = __webpack_public_path__ + "img/voicemail.d6a663f6.svg";